import { QUICKLAUNCH_INIT_LOADING, QUICKLAUNCH_INIT_SUCCESS, QUICKLAUNCH_INIT_FAIL, QUICKLAUNCH_ADD, QUICKLAUNCH_REMOVE } from '@/store/types'

export const mutations = {
  [QUICKLAUNCH_INIT_LOADING](state) {
    state.quickLaunch.init = 0
  },
  [QUICKLAUNCH_INIT_SUCCESS](state, data) {
    state.quickLaunch.menu = data.menu
    state.quickLaunch.apps = data.data
    state.quickLaunch.init = 1
  },
  [QUICKLAUNCH_INIT_FAIL](state) {
    state.quickLaunch.init = 2
  },
  [QUICKLAUNCH_ADD](state, data) {
    if (!state.quickLaunch.apps.includes(data)) {
      state.quickLaunch.apps.push(data)
    }
  },
  [QUICKLAUNCH_REMOVE](state, data) {
    if (state.quickLaunch.apps.includes(data)) {
      const index = state.quickLaunch.apps.indexOf(data)
      state.quickLaunch.apps.splice(index, 1)
    }
  }
}
